import __request__ from "routing/request";
export function list(requestOptions) {
  return __request__("GET", "/system/cluster_config", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function schema(configClass, requestOptions) {
  return __request__("GET", `/system/cluster_config/${configClass}`, null, {}, {
    "Accept": ["application/schema+json"]
  }, requestOptions);
}
export function update(configClass, body, requestOptions) {
  return __request__("PUT", `/system/cluster_config/${configClass}`, body, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function read(configClass, requestOptions) {
  return __request__("GET", `/system/cluster_config/${configClass}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function remove(configClass, requestOptions) {
  return __request__("DELETE", `/system/cluster_config/${configClass}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
